/* Tandoori Masala — Diseño F · núcleo: datos, domicilio/recoger, ventana emergente */
(function () {
  'use strict';
  var CFG = { stores: [], whatsapp: '34624521437' };
  try { var el = document.getElementById('tm-config'); if (el) CFG = JSON.parse(el.textContent); } catch (e) {}

  var KEY = 'tm_mode_v1';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  var T = window.TMF = window.TMF || {};
  T.CFG = CFG;
  T.state = load(); // {mode:'delivery'|'pickup', cp:'28232', store:'las-rozas'}
  T.$ = function (s, r) { return (r || document).querySelector(s); };
  T.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  T.money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  T.eur = function (n) { return Number(n || 0).toFixed(2).replace('.', ',') + ' €'; };
  T.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  T.storeById = function (id) { for (var i = 0; i < CFG.stores.length; i++) if (CFG.stores[i].id === id) return CFG.stores[i]; return null; };
  T.activeStore = function () { return T.state.store ? T.storeById(T.state.store) : null; };
  var $ = T.$, $$ = T.$$, eur = T.eur, esc = T.esc;

  function parseZips(str) {
    var out = [];
    String(str || '').split(/[\s,;]+/).forEach(function (tok) {
      if (!tok) return;
      var m = tok.match(/^(\d{5})-(\d{5})$/);
      if (m) out.push([parseInt(m[1], 10), parseInt(m[2], 10)]);
      else if (/^\d{5}$/.test(tok)) { var n = parseInt(tok, 10); out.push([n, n]); }
    });
    return out;
  }
  CFG.stores.forEach(function (s) { s._z = parseZips(s.zips); s.min = parseFloat(s.min) || 0; s.fee = parseFloat(s.fee) || 0; });
  T.storeForCp = function (cp) {
    if (!/^\d{5}$/.test(cp)) return null;
    var n = parseInt(cp, 10);
    for (var i = 0; i < CFG.stores.length; i++) {
      var z = CFG.stores[i]._z;
      for (var j = 0; j < z.length; j++) if (n >= z[j][0] && n <= z[j][1]) return CFG.stores[i];
    }
    return null;
  };

  function modeTexts() {
    var st = T.activeStore(), s = T.state;
    if (s.mode === 'delivery' && st) return { l1: 'A domicilio · ' + s.cp, l2: 'Cocina ' + st.name + ' · Mín. ' + eur(st.min) + ' · Envío ' + (st.fee > 0 ? eur(st.fee) : 'gratis'), chip: 'Domicilio · ' + s.cp };
    if (s.mode === 'pickup' && st) return { l1: 'Recoger en ' + st.name, l2: st.address || '', chip: 'Recoger · ' + st.name };
    return { l1: 'Elige cómo quieres tu pedido', l2: 'A domicilio o para recoger en el restaurante', chip: '' };
  }
  T.renderMode = function () {
    var t = modeTexts();
    $$('[data-tm-l1]').forEach(function (n) { n.textContent = t.l1; });
    $$('[data-tm-l2]').forEach(function (n) { n.textContent = t.l2; });
    $$('[data-tm-chip]').forEach(function (n) { n.textContent = t.chip; n.hidden = !t.chip; });
    $$('[data-tm-seg]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-tm-seg') === T.state.mode); });
    T.applyAvailability();
  };
  /* Oculta platos/categorías que el restaurante elegido no vende (p. ej. kebab solo en Fuenlabrada y Albacete) */
  T.applyAvailability = function () {
    var st = T.activeStore();
    $$('[data-tm-only]').forEach(function (n) {
      var list = (n.getAttribute('data-tm-only') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      n.hidden = !!(st && list.length && list.indexOf(st.id) === -1);
    });
  };

  var toastTimer;
  T.toast = function (text) {
    var t = $('#tm-toast'); if (!t) return;
    t.textContent = text; t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 2200);
  };

  T.updateCartAttributes = function () {
    var st = T.activeStore(); if (!st) return;
    var attrs = { 'Modo de pedido': T.state.mode === 'delivery' ? 'A domicilio' : 'Recoger en restaurante', 'Restaurante': st.name, 'Código postal': T.state.mode === 'delivery' ? T.state.cp : '' };
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  };

  /* ---- Ventana: A domicilio (código postal) / A recoger (restaurante) ---- */
  var modal = $('#tm-mode-modal');
  T.modal = modal;
  T.pendingStore = null;
  T.afterChoose = null;
  T.unlock = function () { document.documentElement.style.overflow = ''; };
  T.openModal = function (tab, opts) {
    if (!modal) return;
    opts = opts || {};
    var cart = $('#tm-cart'); if (cart) cart.hidden = true;
    T.afterChoose = opts.after || null;
    T.pendingStore = opts.store || (T.state.mode === 'pickup' ? T.state.store : null);
    var msg = $('[data-tm-modal-msg]', modal);
    if (msg) { msg.textContent = opts.msg || ''; msg.hidden = !opts.msg; }
    T.showTab(tab || 'delivery');
    var cpIn = $('#tm-cp', modal);
    if (cpIn && T.state.cp) cpIn.value = T.state.cp;
    T.renderPickList();
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var f = tab === 'pickup' ? $('.tm-radio', modal) : cpIn; if (f) f.focus(); }, 30);
  };
  T.closeModal = function () { if (!modal) return; modal.hidden = true; T.unlock(); };
  T.showTab = function (tab) {
    $$('[data-tm-tab]', modal).forEach(function (b) { var on = b.getAttribute('data-tm-tab') === tab; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    $$('[data-tm-pane]', modal).forEach(function (p) { p.hidden = p.getAttribute('data-tm-pane') !== tab; });
    var title = $('[data-tm-modal-title]', modal);
    if (title) title.textContent = tab === 'pickup' ? 'A recoger' : 'A domicilio';
  };
  T.renderPickList = function () {
    if (!modal) return;
    $$('[data-tm-pick]', modal).forEach(function (b) { var on = b.getAttribute('data-tm-pick') === T.pendingStore; b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var cta = $('[data-tm-confirm-pickup]', modal);
    if (cta) { var st = T.storeById(T.pendingStore); cta.classList.toggle('is-disabled', !st); cta.textContent = st ? 'Pedir en ' + st.name : 'Elige un restaurante'; }
  };
  T.checkCp = function () {
    var input = $('#tm-cp', modal), box = $('[data-tm-cp-result]', modal);
    if (!input || !box) return;
    var cp = (input.value || '').replace(/\D/g, '').slice(0, 5);
    input.value = cp;
    var html;
    if (cp.length !== 5) {
      html = '<div class="tm-result__err">Introduce un código postal de 5 cifras.</div>';
    } else {
      var st = T.storeForCp(cp);
      if (st) {
        html = '<div class="tm-result__ok">¡Llegamos a ' + esc(cp) + '! Te lo prepara Tandoori Masala ' + esc(st.name) + '.</div>' +
          '<div class="tm-stats"><div class="tm-stat"><small>Pedido mínimo</small><strong>' + eur(st.min) + '</strong></div>' +
          '<div class="tm-stat"><small>Gastos de envío</small><strong>' + (st.fee > 0 ? eur(st.fee) : 'Gratis') + '</strong></div></div>' +
          '<button type="button" class="tm-btn tm-btn--gold tm-btn--block" data-tm-confirm-delivery="' + esc(st.id) + '" data-cp="' + esc(cp) + '">Ver la carta</button>';
      } else {
        var wa = 'https://wa.me/' + CFG.whatsapp + '?text=' + encodeURIComponent('Hola, ¿repartís en el código postal ' + cp + '?');
        html = '<div class="tm-result__err">Todavía no tenemos tu código postal ' + esc(cp) + ' en la web.</div>' +
          '<p class="tm-muted">Escríbenos por WhatsApp y te confirmamos, o recoge tu pedido en un restaurante.</p>' +
          '<div class="tm-row"><a class="tm-btn tm-btn--pink" href="' + wa + '" target="_blank" rel="noopener">Preguntar por WhatsApp</a>' +
          '<button type="button" class="tm-btn tm-btn--ghost" data-tm-tab="pickup">Recoger en restaurante</button></div>';
      }
    }
    box.innerHTML = html;
    box.hidden = false;
  };
  T.choose = function (newState) {
    var prev = T.activeStore();
    T.state = newState;
    save(T.state);
    T.renderMode();
    T.closeModal();
    T.updateCartAttributes();
    var st = T.activeStore();
    if (st) T.toast(T.state.mode === 'delivery' ? 'A domicilio desde ' + st.name : 'Recoger en ' + st.name);
    if (prev && st && prev.id !== st.id && T.refreshCart) T.refreshCart();
    var go = T.afterChoose;
    if (!go && !/^\/(collections|products|cart|checkout)/.test(window.location.pathname)) go = '/collections';
    T.afterChoose = null;
    if (go) window.location.href = go;
  };
})();